import {MetaTitleDesc} from "../meta";
import DocumentMeta from "react-document-meta";

export default () => {
    const title = 'Кадило сарматское';

    return (
        <>
            <DocumentMeta {...MetaTitleDesc(title, title)} />

            <div id="content">
                <div className="pageitem">
                    <h2>{title}</h2>
                    <p className="sub">Melittis sarmatica. Кадзiла сармацкае</p>

                    <img src={require('./../img/topics/MelittisSarmatica/melittissarmatica.jpg')} />

                    <p>Редкий вид, находящийся под угрозой прямого истребления. В Белоруссии проходит восточная граница
                        его ареала. Занесён в Красную книгу БССР. Сокращение численности вызвано сбором растений в
                        качестве лекарственного сырья, изменением мест произрастания под влиянием хозяйственного
                        освоения территорий.</p>
                    <p>В народе этот мягкоопушённый травянистый многолетник с прямостоячим стеблем называют бальзамом
                        или лесным табаком. На первый взгляд он напоминает глухую крапиву или яснотку белую. Листья его
                        широкоэллиптические с городчато-пильчатым краем. Крупные (3—4 см длиной) двугубые цветки с
                        сильным медовым запахом собраны по 2—6 в пазухах верхних листьев. Чашечка колокольчатая,
                        светло-зелёная, кожистая; венчик почти в 2 раза длиннее чашечки, белый, с нижней трёхлопастной
                        губой, средняя доля которой сиреневая или розовая. Плод при созревании распадается на 4
                        яйцевидных орешка.</p>
                    <p>Лекарственные свойства. Травяную массу применяют при расстройстве желудка, катаре, нарывах во рту
                        и горле, а также в качестве мочегонного, рано-заживляющего средства. Настой, приготовленный из
                        свежих цветков, действует освежающе (подобно мяте), возбуждает перистальтику кишечника,
                        устраняет боли в подложечной области. Горячий чай, заваренный из цветков, применяют как
                        потогонное средство.</p>
                    <p>В народной медицине настойку из травы пьют при язве желудка и двенадцатиперстной кишки, болях в
                        желудке, кишечнике, заболеваниях печени, сердца, гинекологических. Наружно настойкой
                        обрабатывают раны и язвы.</p>
                </div>
            </div>
        </>
    );
}